export default __webpack_public_path__ + "static/top_mv_title-99f12fcd7d00778812c0e7a611fd8f01.svg";